/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import AvatarPartnerExample from '../examples/AvatarPartner';
import AvatarPartnerGreaterExample from '../examples/AvatarPartnerGreater';
const AvatarPartnerExampleSource = require('!!raw-loader!../examples/AvatarPartner');
const AvatarPartnerGreaterExampleSource = require('!!raw-loader!../examples/AvatarPartnerGreater');
export default class BoxesPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Avatar for partners"/>
                <h3>Avatar for partner</h3>
                <p>
                    This is used for partners from education programs, where is possible to show only a limited count of
                    avatars at one line. It's possible to use greater avatars, but it's not possible to have the same
                    count of avatars.
                </p>
                <div className="docs-example">
                    <AvatarPartnerExample />
                    <AvatarPartnerGreaterExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{AvatarPartnerExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{AvatarPartnerGreaterExampleSource}</PrismCode>
                </pre>
            </div>);
    }
}
